import React from 'react';
import { connect } from 'react-redux';
import { create as createAssessmentTemplate } from 'js/actions/assessment-template-actions';
import { useSelector } from 'react-redux';
import { baseDocState } from 'js/utils/template-doc';
import { useHistory } from 'react-router-dom';
import AssessmentCreatorComponent from '../components/AssessmentCreatorComponent';

const CreateAssessment = ({ createAssessmentTemplate }) => {
  const currentWorkspaceId = useSelector((state) => state.currentWorkspaceId);
  const history = useHistory();

  const handleSubmit = async (values) => {
    const type = values.type ?? 'survey';

    return createAssessmentTemplate(
      values,
      baseDocState(type, { meta: values })
    )
      .then((res) => {
        console.log('res:', res);
        history.push(`/w/${currentWorkspaceId}/assessments/${res.id}/edit`);
      })
      .catch((e) => {
        console.error('Failed to create assessment template:', e);
      });
  };

  return <AssessmentCreatorComponent onCreate={handleSubmit} />;
};

export default connect(null, {
  createAssessmentTemplate,
})(CreateAssessment);
